
import Layouts from "."
import { ID } from "../interfaces/layouts"

export function title(): string {
  return Layouts().app?.title || "Protopia Ecosystem"
}

export function default_login() {
  return Layouts().app?.default_login
}

export function is_register() {
  return Layouts().app?.is_register
}

export function coords(): number[] {
  return Layouts().app?.coords || []
}

export function init_method() {
  return Layouts().app?.init_method || "static"
}
export function name() {
  return Layouts().app?.name
}

export function subtitle(): string {
  return Layouts().app?.subtitle || ""
}

export function image(): string {
  return Layouts().app?.image || ""
}

export function description(): string {
  return Layouts().app?.description || ""
}
export function help_url()
{
  return Layouts().app?.help_url
}

export function externalSystems(): string[] {
  return Layouts().app?.external_systems
}
export function roles() {
  return Layouts().app?.roles
}
// export function adapter() {
//   return Layouts().app?.adapter
// }
export function userModel() {
  return Layouts().app?.user_model
}
//export default Layouts().app;

export function land_group_id(): ID {
  return Layouts().app?.land_group_id || ""
}
export function is_custom_http_header(): boolean {
  return !!Layouts().app?.is_custom_http_header
}
